import React from 'react';
import { useSnackbar } from '../../../../context/SnackBarContext';
import MultipleSelect from '../../../../component/MultipleSelect';

export const EditPurchaseOrderForm = ({
    setFormData,
    formData,
    setModalOpen,
    updateFunc,
    tableData,
    setTableData
}) => {
    const { showError } = useSnackbar();

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log("name ===>>", name, value)
    //     if(name == "issueQuantity"){
    //         tableData((prev)=>{

    //         })
    //     }
    //     setFormData({ ...formData, [name]: value });
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
      
        if (name === "issueQuantity") {
          const issueQty = parseFloat(value) || 0;
      
          setTableData((prev) => {
            const updatedItems = prev.item.map((itm) => {
              const avg = parseFloat(itm.avg).toFixed(2);
              const rate = parseFloat(itm.rate).toFixed(2);
      
              return {
                ...itm,
                colQty: Number(((issueQty / 4) * avg).toFixed(2)),
                quantity: Number((issueQty * avg).toFixed(2)),
                total: Number((issueQty * avg * rate).toFixed(2)),
              };
            });
      
            return {
              ...prev,
              item: updatedItems,
            };
          });
        }
      
        setFormData((prev) => ({ ...prev, [name]: value }));
      };

    const handleSaveButton = () => {
        setModalOpen(true)
    }

    const optionsSize = [
        { name: 'Small' },
        { name: 'Medium' },
        { name: 'Large' },
    ];

    const optionsDelivery = [
        { name: 'Home' },
        { name: 'Office' },
        { name: 'Pickup Point' },
    ];

    const optionsColor = [
        { name: 'Red' },
        { name: 'Blue' },
        { name: 'Pink' },
    ];

    const handleChooseStyle = () => {
        if (!(formData.issueQuantity).trim()) {
            showError("Please enter the Issue Quantity before selecting a style name.")
            return
        }
        updateFunc({ isProductDrawerOpen: true })
    }

    //  total
    let total = tableData.item.reduce((sum, item) => {
        const itemTotal = parseFloat(item.total) || 0;
        return sum + itemTotal;
    }, 0);

    total = Math.round(total);

    return (
        <div>
            <div className="flex justify-between items-center mb-4 bg-[#f4f5f7] pb-3 md:px-0 px-3">
                <h2 className="md:text-[28px] text-[20px] font-bold text-gray-800">Edit Purchase Order</h2>
                <button
                    onClick={() => handleSaveButton()}
                    className="md:px-4  px-2 md:py-2 py-1  bg-gray-800 text-white border-gray-400 border rounded hover:bg-black">
                    Save
                </button>
            </div>
            <div className="md:px-5 px-2">
                <div className="flex md:flex-row flex-col justify-between pt-3">
                    <div className='flex justify-end mr-15'>
                        <div className="flex flex-row justify-center items-center mb-4">
                            <p className="text-gray-700 mr-2">Total :</p>
                            <span className="text-gray-700 text-[24px] font-bold ">₹{total || "0.00"}</span>
                        </div>
                    </div>
                </div>

                <div>
                    <button
                        onClick={handleChooseStyle}
                        className="md:px-4  px-2 md:py-2 py-1  bg-gray-800 text-white border-gray-400 border rounded hover:bg-black">
                        Choose Style Name
                    </button>
                </div>

                <div>
                    <div className="grid md:grid-cols-6 flex-wrap gap-4 mb-6 max-w-[1000px] mt-5">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Supplier</label>
                            <input
                                type="text"
                                name="supplier"
                                value={formData.supplier}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Supplier"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-bold text-gray-700 mb-2">SIZE </label>
                            <MultipleSelect
                                label="Size"
                                options={optionsSize}
                                value={formData.size}
                                onChange={handleChange}
                                name="size"
                                placeholder="Size"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Fabricator</label>
                            <input
                                type="text"
                                name="fabricator"
                                value={formData.fabricator}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Fabricator"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">STYLE NO</label>
                            <input
                                type="text"
                                name="styleNo"
                                value={formData.styleNo}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Style No"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Style Name</label>
                            <input
                                type="text"
                                label="Style Name"
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                value={formData.styleName}
                                onChange={handleChange}
                                name="styleName"
                                placeholder="Style Name"
                                disabled

                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">REMARKS</label>
                            <input
                                type="text"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Remarks"
                            />
                        </div>
                    </div>

                    <div className="grid md:grid-cols-6  flex-wrap gap-4 mb-6 max-w-[1000px] mt-4">
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">DATED *</label>
                            <input
                                type="date"
                                name="dated"
                                value={formData.dated}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Select Date"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">DELIVERY DATE *</label>
                            <input
                                type="date"
                                name="deliveryDate"
                                value={formData.deliveryDate}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Select Delivery Date"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Delivery At</label>
                            <MultipleSelect
                                label="Delivery At"
                                options={optionsDelivery}
                                value={formData.deliveryAt}
                                onChange={handleChange}
                                name="deliveryAt"
                                placeholder="Delivery At"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">ISSUE QUANTITY*</label>
                            <input
                                type="number"
                                name="issueQuantity"
                                value={formData.issueQuantity}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Issue Quantity"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2"> COLOR</label>
                            <MultipleSelect
                                label="Color"
                                options={optionsColor}
                                value={formData.color}
                                onChange={handleChange}
                                name="color"
                                placeholder="Color"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};